import type { TranslationCatalog } from "../TranslationManager";

export const bn: TranslationCatalog = {
  "labels.cardNumber": "কার্ড নম্বর",
  "labels.expirationDate": "মেয়াদ শেষের তারিখ",
  "labels.cvc": "নিরাপত্তা কোড",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "MM / YY",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "আপনার কার্ড নম্বরটি অবৈধ।",
  "errors.invalidExpiryDate": "আপনার কার্ডের মেয়াদ শেষের তারিখটি অবৈধ।",
  "errors.invalidCvc": "আপনার কার্ডের নিরাপত্তা কোডটি অবৈধ।",
  "errors.incompleteCardNumber": "আপনার কার্ড নম্বরটি অসম্পূর্ণ।",
  "errors.incompleteExpiryDate": "আপনার কার্ডের মেয়াদ শেষের তারিখটি অসম্পূর্ণ।",
  "errors.incompleteCvc": "আপনার কার্ডের নিরাপত্তা কোডটি অসম্পূর্ণ।",
  "errors.expiredCard": "আপনার কার্ডের মেয়াদ শেষ হয়ে গেছে।",
  "aria.cardNumber": "কার্ড নম্বর",
  "aria.expirationDate": "মেয়াদ শেষের তারিখ",
  "aria.cvc": "নিরাপত্তা কোড",
  "aria.cardInput": "কার্ড তথ্য",
};
